import { faWifi } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Alert, AlertProps } from 'react-bootstrap';

export default function OfflineAlert({
  message,
  className,
  variant = 'warning',
}: {
  message: string;
  className?: string;
  variant?: AlertProps['variant'];
}) {
  const initialStatus =
    typeof navigator?.onLine !== 'undefined' ? navigator.onLine : true;
  const [isOnline, setIsOnline] = useState<boolean>(initialStatus);

  useEffect(() => {
    const onlineListener = () => setIsOnline(true);
    const offlineListener = () => setIsOnline(false);
    window.addEventListener('online', onlineListener);
    window.addEventListener('offline', offlineListener);

    // Remove listeners on unmount
    return () => {
      window.removeEventListener('online', onlineListener);
      window.removeEventListener('offline', offlineListener);
    };
  }, []);

  // Return null if online
  if (isOnline) return null;

  // Otherwise return the notification
  return (
    <Alert variant={variant} className={className}>
      <p className="mb-0">
        <strong>
          <FontAwesomeIcon icon={faWifi} className="me-1" /> You're offline.
        </strong>{' '}
        <span>{message}</span>
      </p>
    </Alert>
  );
}
